import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import facebookBwIcon from '@/assets/facebook_bw.svg';
import instagramBwIcon from '@/assets/instagram_bw.svg';
import xBwIcon from '@/assets/x_bw.svg';

import orderIcon from '@/assets/order.svg';
import heartIcon from '@/assets/heart.svg';
import avatarIcon from '@/assets/avatar.svg';
import Button from '@/components/Button';
import SearchInput from '@/components/SearchInput';
import NotificationDropdown from '@/components/NotificationDropdown';
import useAuthStore from '@/stores/authStore';
import { getAvatarThumbnailUrl } from '@/utils/imageUtils';

const Header = () => {
  const { t } = useTranslation();
  const accessToken = useAuthStore((state) => state.accessToken);
  const user = useAuthStore((state) => state.user);
  const location = useLocation();
  const handleLogoClick = (event) => {
    if (location.pathname === '/') {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  };
  
  // Hide auth buttons on login, signup, and forgot-password pages
  const isAuthPage = ['/login', '/signup', '/forgot-password'].includes(location.pathname);

  return (
    <div className="flex flex-col w-full sticky top-0 z-50">
      {/* Top bar */}
      <div className="w-full bg-white border-b border-[#f4f4f4]">
        <div className="container py-1.5 flex justify-end items-center gap-[22px]">
          <a href='https://www.facebook.com/profile.php?id=61578369303158' target='_blank'>
            <img src={facebookBwIcon} alt="Facebook" className="w-[18px] h-[18px]" />
          </a>
          <a href='https://www.instagram.com/dondon_card/' target='_blank'>
            <img src={instagramBwIcon} alt="Instagram" className="w-[18px] h-[18px]" />
          </a>
          <a href='https://x.com/DONDON_JP_APP' target='_blank'>
            <img src={xBwIcon} alt="X" className="w-[18px] h-[18px]" />
          </a>
        </div>
      </div>

      {/* Main header */}
      <div className="w-full bg-white border-b border-[#f4f4f4]">
        <div className="container py-3.5 flex justify-between items-center">
          <div className="flex items-center gap-12">
            <Link to="/" onClick={handleLogoClick}>
              <img className="h-9" src="/dondon-logo.svg" alt="Logo" />
            </Link>
          </div>

          <div className="h-9 flex items-center gap-4">
            {!isAuthPage && <SearchInput />}

            {accessToken ? (
              <div className="flex items-center gap-3">
                <NotificationDropdown />
                <Button 
                  className="w-9 h-9 !px-0" 
                  as={Link} 
                  to="/me/favorites"
                >
                  <img src={heartIcon} alt="Favorites" className="w-4 h-4" />
                </Button>
                <Button 
                  className="w-9 h-9 !px-0" 
                  as={Link} 
                  to="/me/orders"
                >
                  <img src={orderIcon} alt="Orders" className="w-4 h-4" />
                </Button>
                <Button 
                  className="h-9 pl-1.5 pr-3 gap-1.5" 
                  as={Link} 
                  to="/me"
                >
                  <div className="w-6 h-6 relative">
                    <div className="w-6 h-6 rounded-full">
                      <img src={getAvatarThumbnailUrl(user?.avatar?.url) || avatarIcon} alt="Avatar" className="w-6 h-6 absolute left-[0px] top-[0px] rounded-full object-cover" />
                    </div>
                  </div>
                  <span className="text-[#111111] text-sm">{user?.nickname || 'User'}</span>
                </Button>
              </div>
            ) : (
              !isAuthPage && (
                <div className="flex items-center gap-4">
                  <Button
                    variant="default"
                    size="m"
                    as={Link}
                    to="/login"
                    className="border-[#111111]"
                  >
                    {t('navigation.login')}
                  </Button>
                  
                  <Button
                    variant="primary"
                    size="m"
                    as={Link}
                    to="/signup"
                  >
                    {t('navigation.sign_up')}
                  </Button>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header; 
